import { RetryLink } from '@apollo/client/link/retry';

export const retryLink = new RetryLink({
    delay: {
        initial: 100, // Initial delay in ms
        jitter: true, // Add randomness to delay for reducing collisions
    },
    attempts: (count, operation, error) => {
        if (error?.statusCode === 401) {
            // Just pass to errorLink
            return false;
        }

        const context = operation.getContext();

        if (!context?.retryAttempts) {
            return false;
        }

        return count < context.retryAttempts;
    },
});
